import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = false;

const instance = axios.create({
	timeout: 300000,
	baseURL: import.meta.env.VITE_BASE_API || '',
});

const pendingList = new Map();
const getFetchKey = (config) => {
	const { url, data, method, params } = config;
	let token;
	if (method === 'get') {
		token = [method, url, JSON.stringify(params)].join('&');
	} else {
		token = [method, url, JSON.stringify(data)].join('&');
	}
	return token;
};
const addPending = (config) => {
	const fetchKey = getFetchKey(config);
	if (fetchKey) {
		config.cancelToken =
			config.cancelToken ||
			new axios.CancelToken((cancel) => {
				if (!pendingList.has(fetchKey)) {
					pendingList.set(fetchKey, cancel);
				}
			});
	}
};
const removePending = (config) => {
	const fetchKey = getFetchKey(config);
	if (fetchKey && pendingList.has(fetchKey)) {
		pendingList.delete(fetchKey);
	}
};
const cancelPending = (config) => {
	const fetchKey = getFetchKey(config);
	if (fetchKey && pendingList.has(fetchKey)) {
		console.warn(`${config.url}: 短时间内重复请求`);
		const cancel = pendingList.get(fetchKey);
		cancel('cancel');
		pendingList.delete(fetchKey);
	}
};

instance.interceptors.request.use(
	(request) => {
		cancelPending(request);
		addPending(request);
		return request;
	},
	(error) => Promise.reject(error)
);

instance.interceptors.response.use(
	(response) => {
		removePending(response);
		return response.data;
	},
	(error) => {
		removePending(error.response);
		return Promise.reject(error);
	}
);

const service = {
	get(url, data) {
		return instance.get(url, { params: data });
	},
	post(url, obj) {
		return instance.post(url, obj);
	},
	gate(url, obj) {
		return instance.post(url, obj.data, obj);
	},
};
export { service };
